import { z } from 'zod';

export const reviewHistoryItemSchema = z.object({
  id: z.string(),
  challengeId: z.number(),

  answer: z.string(),
  level: z.number(),
  timeSpent: z.number(),
  timestamp: z.number(),
  challengeTitle: z.string(),
  device: z.string().nullable(),
  pointsEarned: z.number().int(),
});

export type IReviewHistoryItem = z.infer<typeof reviewHistoryItemSchema>;
